import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatTypeForHeader } from './formatTypeForHeader';
import { Badge } from '@criteria-labs/react';
function SchemaTypeBadge({ children }) {
    return (_jsx(Badge, { className: "text-xs/5", color: "zinc", children: children }));
}
function RequiredBadge() {
    return (_jsx(Badge, { className: "ml-2 text-xs/5", color: "red", children: "required" }));
}
function SchemaFormatBadge({ children }) {
    return (_jsx(Badge, { className: "ml-2 text-xs/5", color: "yellow", children: children }));
}
export function HeaderHeading({ header }) {
    const formattedType = formatTypeForHeader(header);
    return (_jsxs("h4", { className: "text-xs font-medium leading-6 text-zinc-950 dark:text-white", children: [formattedType && _jsx(SchemaTypeBadge, { children: formattedType }), typeof header.schema === 'object' && typeof header.schema.format === 'string' && (_jsx(SchemaFormatBadge, { children: header.schema.format })), header.required && _jsx(RequiredBadge, {})] }));
}
